import React from 'react';
import logo from '../icons/gymx-final-white.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

function Footer() {
  return (
    <>
      <footer>
        {/* Top Section */}
        <div className='bg-[#F7931E] pt-3'>
          <div className='bg-[#022A3A]'>
            <div className='flex flex-col md:flex-row justify-between items-center px-4 md:px-20 py-5 space-y-4 md:space-y-0'>
              {/* Logo */}
              <div>
                <img src={logo} alt='GymXS Logo' className='w-32 md:w-40 h-auto' />
              </div>

              {/* Contact Info */}
              <div className='space-y-2 text-sm text-white text-center md:text-left px-4 md:px-16'>
                <p className='flex items-center justify-center md:justify-start'>
                  <FontAwesomeIcon icon={faPhone} className='text-gray-400 mr-2' />
                  Phone: +971 56 8717517
                </p>
                <p className='flex items-center justify-center md:justify-start'>
                  <FontAwesomeIcon icon={faEnvelope} className='text-gray-400 mr-2' />
                  Email:{' '}
                  <a href='mailto:info@gymxs.net' className='text-[#3c8dbc] ml-1'>
                    info@gymxs.net
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className='bg-black flex flex-col md:flex-row justify-between items-center px-4 md:px-20 py-4 space-y-2 md:space-y-0'>
          {/* Copyright */}
          <p className='text-sm text-white text-center md:text-left'>
            © 2016 - All Rights Reserved
          </p>

          {/* Navigation Links */}
          <nav className='flex flex-wrap justify-center md:justify-start space-x-2 text-sm text-white'>
            <a href='#about'>Home/</a>
            <a href='#about'>About Us/</a>
            <a href='#pricing'>Product Pricing/</a>
            <a href='#contact'>Contact Us/</a>
            <a href='#policy'>Privacy Policy/</a>
            <a href='#about'>Terms & Conditions/</a>
            <a href='#about'>Delivery Policy/</a>
            <a href='#about'>Refund & Cancellation Policy</a>
          </nav>
        </div>
      </footer>
    </>
  );
}

export default Footer;